<template>
  <card id="endDeviceLastMessages" :title="$t('ed-lastMessages:lastMessages')" no-body no-footer>
    <table slot="card-table" class="table table-sm table-ellipsis mb-0">
      <tbody>
        <tr>
          <td>{{ $t('ed-lastMessages:lastDataUpMessage') | capitalize }}</td>
          <td v-if="endDevice.lastDataUpDate">{{ endDevice.lastDataUpDate | date }}</td>
          <td v-else class="text-muted font-italic">{{ $t('ed-lastMessages:noDataUpMessages') | capitalize }}</td>
        </tr>
        <tr>
          <td>{{ $t('ed-lastMessages:lastDataDownMessage') | capitalize }}</td>
          <td v-if="endDevice.lastDataDownDate">{{ endDevice.lastDataDownDate | date }}</td>
          <td v-else class="text-muted font-italic">{{ $t('ed-lastMessages:noDataDownMessages') | capitalize }}</td>
        </tr>
      </tbody>
    </table>
  </card>
</template>

<script>
export default {
  props: {
    endDevice: {
      type: Object,
      required: true
    }
  }
}
</script>
